// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"f90d72d1","256":"7af2988b","258":"bbc18178","313":"74da3de3","507":"82c94f90","521":"d1516817"}[chunkId] + ".chunk.js";
};